import React from "react"

const formatAndRenderInPageJumpNav = (data) => {
  const displayedSections = []
  
  if (data && data !== null && Array.isArray(data)) {
    data?.forEach(section => {
      if (section != null && section?.anchor && section?.jumpNavTitle) {
        section.link = section?.anchor
        section.title = section?.jumpNavTitle
        displayedSections.push(section)
      }
    })
  }
  return displayedSections
}

export default formatAndRenderInPageJumpNav
